module.exports = __webpack_public_path__ + "static/media/education.b7a57eb6.png";